module.exports = __webpack_public_path__ + "img/arqu-cabc-02.e43cee0f.jpg";